import React, { Component } from 'react'
import { Col, Row } from 'reactstrap'
import slugify from 'slugify'
import { withRouter, Link } from 'react-router-dom'
import HighLevelCard from './HighLevelCard'

class HighLevelCategories extends Component {
  render () {
    const { categories, urlFrameworkName, frameworkName, headingDescription } = this.props

    return (
      <div>
        <Row>
          <Col md={12} id='highLevelHeading'>
            <h3 className='page-title'>{frameworkName} Compliance</h3>
            <h3 className='page-subhead subhead'>{headingDescription || 'All your compliance details in one view!'}</h3>
          </Col>
        </Row>
        <Row>
          {categories.map((category, idx) => {
            const applicableControls = category.numberOfControls; //- category.numberOfNotApplicableControls;
            return (
              <Link
                className="col-md-12 col-lg-4"
                key={idx}
                to={`/app/compliance/${urlFrameworkName}/${slugify(category.name.toLowerCase())}`}
              >
                <HighLevelCard
                  id={slugify(category.name)}
                  title={category.name}
                  percentage={
                    applicableControls > 0 ?
                      `${(((category.numberOfCompliantControls+category.numberOfNotApplicableControls) /
                        applicableControls) * 100).toFixed(0)}%` : 'N/A'
                  }
                  description={category.description}
                  clickable
                  percentage_color={applicableControls === 0 || category.numberOfCompliantControls === 0 ?
                    "#2d9aa6" : '#2d9aa6'}
                  hoverColor
                  isActive={false}
                  bgColor='white-bg'
                />
              </Link>)
          }
          )}
        </Row>
      </div>
    )
  }
}

export default withRouter(HighLevelCategories)



// WEBPACK FOOTER //
// ./src/components/compliance/components/HighLevelCategories.js